import CustomFormSelect from "components/bootstrap/CustomSelectControl";
import FormControlIndiseReactHookForm from "components/bootstrap/FormControlIndiseReactHookForm";
import SelectInsideReactHookForm from "components/bootstrap/SelectInsideReactHookForm";
import { convertLicensePlateEnumToArray } from "components/Reports/reportAssets/assets";
import SubTitle from "components/SubTitle";
import React from "react";
import { Form, Col, Container, Row } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormStepsProps } from "../FormStepsProps";

const ReportDetailsInputs = ({
  control,
  errors,
  setValue,
  getValues,
  isAlreadyDuplicated,
}: FormStepsProps) => {
  const { t } = useTranslation();
  return (
    <section className="text-and-select-inputs-report-details-container">
      <SubTitle underLine>{t("details")}</SubTitle>
      <Container>
        <Row>
          <Col className="col-3.5">
            <SelectInsideReactHookForm
              name="licensePlateTypeCode"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: t("validationRequired"),
                },
              }}
              options={convertLicensePlateEnumToArray()}
              label={t("licensePlateType")}
              error={
                errors?.licensePlateTypeCode &&
                errors.licensePlateTypeCode?.message
              }
              isRowNeeded={false}
              isLabelNedded={false}
            />
          </Col>
          <Col className="col-3.5">
            <FormControlIndiseReactHookForm
              setValue={setValue}
              getValues={getValues}
              control={control}
              name="licenseNumber"
              placeholder={t("licenseNumber")}
              rules={{
                required: {
                  value: true,
                  message: t("validationRequired"),
                },
              }}
              error={errors.licenseNumber && errors.licenseNumber?.message}
            />
          </Col>

          <Col className="col-3.5">
            <FormControlIndiseReactHookForm
              setValue={setValue}
              getValues={getValues}
              name="carModel"
              control={control}
              placeholder={t("modelType")}
            />
          </Col>
        </Row>

        <Row>
          <Col className="col-3.5">
            <FormControlIndiseReactHookForm
              setValue={setValue}
              getValues={getValues}
              control={control}
              name="carColor"
              placeholder={t("carColor")}
            />
          </Col>
          <Col className="col-3.5">
            <FormControlIndiseReactHookForm
              setValue={setValue}
              getValues={getValues}
              control={control}
              name="manufacturerName"
              placeholder={t("manufacturerName")}
            />
          </Col>
          <Col className="col-3.5">
            <FormControlIndiseReactHookForm
              setValue={setValue}
              getValues={getValues}
              control={control}
              name="modelType"
              placeholder={t("carModel")}
            />
          </Col>
        </Row>
        <Row>
          <Col className="numbers-select-col">
            <Controller
              name="numOfVehicleInvolve"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: t("validationRequired"),
                },
                min: {
                  value: 1,
                  message: t("validationRequired"),
                },
              }}
              render={({ field: { onChange, value } }) => (
                <>
                  <Form.Label>{t("numberInvolved")}</Form.Label>

                  <CustomFormSelect
                    value={value}
                    onChange={onChange}
                    aria-label="number select example"
                    required
                    className="numbers-select"
                    disabled={isAlreadyDuplicated}
                  >
                    {Array.from(Array(10).keys()).map((num) => (
                      <option key={num + 1} value={num + 1}>
                        {num + 1}
                      </option>
                    ))}
                  </CustomFormSelect>
                  {isAlreadyDuplicated && (
                    <span>{t("cannotDuplicateAnnouncment")}</span>
                  )}
                </>
              )}
            />
          </Col>
          {errors.numOfVehicleInvolve && (
            <span className="requiredField">*{t("validationRequired")}</span>
          )}
        </Row>
      </Container>
    </section>
  );
};
export default ReportDetailsInputs;
